<template>
  <transition-group tag="div" class="app-screens__text" name="text">
    <div
      v-for="(slide, index) in slides"
      v-show="index === currentIndex"
      :key="index"
    >
      <p v-show="index === currentIndex" class="app-screens__text-title">
        {{ slide.textTitle }}
      </p>
      <span v-show="index === currentIndex">{{ slide.text }}</span>
    </div>
  </transition-group>
</template>

<script>
export default {
  name: 'TextContentTransitionGroup',
  props: {
    currentIndex: {
      type: Number,
      default: 0,
    },
    slides: {
      type: Array,
      required: true,
    },
  },
}
</script>

<style lang="postcss">
.text-enter-active,
.text-leave-active {
  transition: opacity 2s cubic-bezier(0.19, 1, 0.22, 1);
}

.text-enter,
.text-leave-to {
  opacity: 0;
}

.text-leave,
.text-enter-to {
  opacity: 1;
}

.app-screens__text-title {
  font-weight: 700;
  font-size: 15px;
}
.app-screens__text {
  --app-screens__text-max-height: 180px;
  display: flex;
  overflow: auto;
  height: var(--app-screens__text-max-height);
  padding-top: var(--spacing-6);
  font-size: 15px;
}

@media (--sm) {
  .app-screens__text {
    --app-screens__text-max-height: 540px;
    padding-top: 0;
    padding-left: var(--spacing-8);
    align-items: center;
    height: var(--app-screens__text-max-height);
    width: auto;
  }
}

@media (--md) {
  .app-screens__text {
    padding-left: var(--spacing-16);
  }
}
</style>
